const e = (t) => {
  const s = {};
  return t.forEach((o) => {
    const r = o.stackId;
    s[r] || (s[r] = []), s[r].push(o.key);
  }), s;
}, a = (t, s, o) => {
  const r = o.indexOf(s);
  return o.slice(r + 1).every((c) => t[c] === 0) ? [10, 10, 0, 0] : [0, 0, 0, 0];
};
export {
  a as calculateBarRadius,
  e as groupKeysByStackId
};
